import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
    return (
        <section className='min-h-screen bg-surface-muted py-20 px-6'>
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className='max-w-4xl mx-auto bg-white rounded-card shadow-premium p-10 lg:p-16'
            >
                <h1 className='text-4xl font-black text-primary mb-8 tracking-tight'>Privacy Policy</h1>
                <div className='prose prose-slate max-w-none space-y-8 text-gray-600 font-medium'>
                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>1. Introduction</h2>
                        <p>Welcome to Shalimar Helmet. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights.</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>2. Data We Collect</h2>
                        <p>We collect and process various types of information, including:</p>
                        <ul className='list-disc pl-6 space-y-2'>
                            <li><strong>Identity Data:</strong> first name, last name, username or similar identifier.</li>
                            <li><strong>Contact Data:</strong> billing address, delivery address, email address and telephone numbers.</li>
                            <li><strong>Transaction Data:</strong> details about payments to and from you and other details of products and services you have purchased from us.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>3. Purpose of Collection</h2>
                        <p>We use your data to provide our services, process your orders, manage your account, and, with your permission, send you information about other products and services we think you may like.</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>4. PCI DSS Compliance & Payment Data</h2>
                        <p>We do not store your credit card details on our servers. All card payments are processed securely via Stripe, a PCI-certified payment provider. Your card data is encrypted and handled according to the Payment Card Industry Data Security Standard (PCI DSS).</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>5. Cookies & Tracking</h2>
                        <p>We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept", you consent to our use of cookies.</p>
                    </section>

                    <section>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>6. Your Rights</h2>
                        <p>Under certain laws (including CCPA/GDPR), you have the right to access, correct, delete, or restrict the processing of your personal data. You also have the right to opt-out of the "sale" of your personal information.</p>
                    </section>

                    <section className='pt-8 border-t border-surface-border'>
                        <h2 className='text-xl font-bold text-primary mb-4 uppercase tracking-widest text-[10px]'>7. Contact Details</h2>
                        <p>If you have any questions about this privacy policy or our privacy practices, please contact us at: <strong>privacy@shalimarhelmet.com</strong></p>
                    </section>
                </div>
            </motion.div>
        </section>
    );
};

export default PrivacyPolicy;
